import { SUBSCRIPTION_ACTION_TYPES } from "../actionTypes";

const initialState = {
  error: "",
  products_loading: false,
  products_error: false,
  products_success: false,
  subscription: {}
};

const RenewReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_ACTION_TYPES.RENEW.RESET:
      return {
        products_loading: false,
        products_error: false,
        products_success: false,
        error: ""
      };
    case SUBSCRIPTION_ACTION_TYPES.RENEW.RENEW_LOADING:
      return {
        ...state,
        products_loading: true,
        products_error: false,
        products_success: false
      };
    case SUBSCRIPTION_ACTION_TYPES.RENEW.RENEW_SUCCESS:
      return {
        ...state,
        subscription: action.payload
      };
    case SUBSCRIPTION_ACTION_TYPES.RENEW.RENEW_ERROR:
      return {
        ...state,
        products_loading: false,
        products_error: true,
        products_success: false,
        error: action.error.message
      };
    default:
      return state;
  }
};

export default RenewReducer;
